import { render } from "./InstanceRequest.vue?vue&type=template&id=cfccaaaa"
import script from "./InstanceRequest.vue?vue&type=script&lang=js"
export * from "./InstanceRequest.vue?vue&type=script&lang=js"

import "./InstanceRequest.vue?vue&type=style&index=0&id=cfccaaaa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__